import { registerCustomElement } from "../../../../../UI.ElementarControls/Utils/CustomElementUtils";
import { BaseAdvancedFilters } from "./BaseAdvancedFilters";

export class QuarterListAdvancedFilter extends BaseAdvancedFilters {
    protected override _constructor(): void {
        super._constructor();

        this.addItems([
            { value: 1, id: "1_q", lockey: "GUI-670794", valueType: "quarterlist" }, //1. kvartál
            { value: 2, id: "2_q", lockey: "GUI-670795", valueType: "quarterlist" }, //2. kvartál
            { value: 3, id: "3_q", lockey: "GUI-670796", valueType: "quarterlist" }, //3. kvartál
            { value: 4, id: "4_q", lockey: "GUI-670797", valueType: "quarterlist" }, //4. kvartál
        ]);
    }
}

registerCustomElement("tsc-QuarterListAdvancedFilter", QuarterListAdvancedFilter);
